import { get } from 'lodash'
import { useCallback, useMemo } from 'react'

import { Maybe } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { UsersImportMappingFragment } from '../../operations/UsersImportFragments.codegen'
import { useFetchReusableImportMappingsQuery } from '../operations/fetchReusableImportMappings.codegen'
import { ReactSelectOption } from '../../../../components/common/select/Select'

export interface IImportMappingOptions {
  options: ReactSelectOption[]
  getMapping: (id: number) => Maybe<UsersImportMappingFragment>
}

export const useImportMappingOptions = (
  columnsCount: number
): IImportMappingOptions => {
  const { data } = useFetchReusableImportMappingsQuery()

  const mappings: UsersImportMappingFragment[] = get(
    data,
    'admin.usersImport.reusableMappings',
    []
  )

  const suitableMappings = useMemo<UsersImportMappingFragment[]>(() => {
    return mappings.filter(({ map }) => map.length === columnsCount)
  }, [mappings, columnsCount])

  const options = useMemo<ReactSelectOption[]>(() => {
    return suitableMappings.map(({ id, title }) => ({
      value: id,
      label: title as string
    }))
  }, [suitableMappings])

  const getMapping = useCallback(
    (lookupId) => {
      return suitableMappings.find(({ id }) => id === lookupId)
    },
    [suitableMappings]
  )

  return {
    options,
    // @ts-expect-error 9/11/2020
    getMapping
  }
}
